import React, { createContext, useRef, forwardRef, useImperativeHandle } from 'react';
import { StateManager } from '@antv/g2plot';
var manager = new StateManager();
export var StateManagerContext = createContext(manager);
var StateManagerProvider = forwardRef(function (_ref, ref) {
  var children = _ref.children;
  var managerRef = useRef(new StateManager());
  useImperativeHandle(ref, function () {
    return managerRef.current;
  }, []);
  return (
    /*#__PURE__*/
    React.createElement(StateManagerContext.Provider, {
      value: managerRef.current
    }, children)
  );
});
export default StateManagerProvider;